import { Page } from "../Page.js";
import { StackPicker } from "../components/StackPicker.js";
import { jobTable } from "../components/JobTable.js";
import { h, patch } from "../dom.js";
import { stackName } from "../format.js";

/** A one-off craft: pick a stack, an amount and optionally a CPU. */
export class RequestPage extends Page {
  readonly title = "Request";
  private readonly cpu = h("select");
  private readonly recent = h("div");

  mount(): void {
    const picker = new StackPicker(this.ctx);
    const qty = h("input", { type: "number", min: "1", value: "1", required: true });
    const send = h("button", { class: "primary", type: "submit" }, "Request craft");
    const form = h(
      "form",
      {
        class: "card",
        onsubmit: async (e: Event) => {
          e.preventDefault();
          const stack = picker.value;
          if (!stack) return this.ctx.toast("Pick something to craft first", "error");
          send.disabled = true;
          const job = await this.attempt(() => this.ctx.api.craft(stack, Number(qty.value), this.cpu.value || undefined));
          send.disabled = false;
          if (job) this.ctx.toast(job.state === "failed" ? `Request failed: ${job.reason}` : `Requested ${qty.value} ${stackName(stack)}`, job.state === "failed" ? "error" : "info");
        },
      },
      h("h2", null, "Request a craft"),
      picker.el,
      h("div", { class: "row" }, h("label", null, "Amount", qty), h("label", null, "CPU", this.cpu), h("span", { class: "spacer" }), send),
      h("p", { class: "muted small" }, "Manual requests may use any CPU, including the ones kept free from automatic crafting. Fluid amounts are in mB."),
    );
    this.el.append(form, h("h2", null, "Your recent requests"), this.recent);
    this.listen("cpus", () => this.renderCpus());
    this.listen("jobs", () => this.renderRecent());
    this.renderCpus();
    this.renderRecent();
    picker.focus();
  }

  private renderCpus(): void {
    const current = this.cpu.value;
    patch(
      this.cpu,
      h("option", { value: "" }, "Any free CPU"),
      // Unnamed CPUs cannot be pinned.
      ...this.ctx.live.cpus.filter((cpu) => !cpu.name.startsWith("#")).map((cpu) => h("option", { key: cpu.name, value: cpu.name, disabled: cpu.busy }, `${cpu.name}${cpu.busy ? " (busy)" : ""}`)),
    );
    if (this.cpu.value !== current) this.cpu.value = current;
  }

  private renderRecent(): void {
    patch(this.recent, jobTable(this.ctx.live.jobList().filter((j) => j.origin === "manual").slice(0, 30), "No manual requests yet."));
  }
}
